import { z } from "zod";

const translationPath = "chatBot.page.automations.automationRules.errors.";

const actionTypeSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().optional().nullable(),
});

const ticketAutomationSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional().nullable(),
    isSendFile: z.boolean(),
    allowTransfer: z.boolean(),
    allowForm: z.boolean(),
    actionTypes: z.array(actionTypeSchema).nullish(),
  },
  { invalid_type_error: translationPath + "ticket_automation" },
);

const ticketChannelWhenErrorSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const ticketChannelStepWhenErrorSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const ticketChannelWhenFinishedSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const ticketChannelStepWhenFinishedSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const automationReceivedRuleSchema = z
  .object({
    id: z.string().optional(),
    enable: z.boolean(),
    name: z.string().min(1, translationPath + "name"),
    description: z.string().nullish(),
    initialDate: z.date({
      invalid_type_error: translationPath + "initial_date",
    }),
    endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
    ticketAutomation: ticketAutomationSchema,
    ticketChannelWhenError: ticketChannelWhenErrorSchema.nullish(),
    ticketChannelStepWhenError: ticketChannelStepWhenErrorSchema.nullish(),
    ticketChannelWhenFinished: ticketChannelWhenFinishedSchema.nullish(),
    ticketChannelStepWhenFinished:
      ticketChannelStepWhenFinishedSchema.nullish(),
    transferMessage: z.string().nullish(),
    errorMessage: z.string().nullish(),
  })
  .superRefine((val, ctx) => {
    if (val.ticketChannelWhenError && !val.ticketChannelStepWhenError) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "list",
        path: ["ticketChannelStepWhenError"],
      });
    }
    if (val.ticketChannelWhenFinished && !val.ticketChannelStepWhenFinished) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: translationPath + "list",
        path: ["ticketChannelStepWhenFinished"],
      });
    }
  });

export type TAutomationReceivedRuleForm = z.infer<
  typeof automationReceivedRuleSchema
>;
